import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src4088909342/src/src/app/ui/common/side-menu.tsx");
